import { Component, OnInit } from '@angular/core';
import { SupplierService } from './supplier.service';
import { Supplier } from './product.types';
import { Router } from '@angular/router';

@Component({
  template: `
    <b4a-product-supplier-list 
        [suppliers]="suppliers" 
        [clickedNew]="clickedNew.bind(this)"
    ></b4a-product-supplier-list>
  `
})
export class SupplierListPageComponent implements OnInit {

  suppliers: Supplier[];

  constructor(private supplierService: SupplierService, private router: Router) {}

  ngOnInit() {
    this.supplierService
      .getSuppliers()
      .subscribe((data) => {
        this.suppliers = data;
      });
  }

  public clickedNew() {
    this.router.navigate(['/products/suppliers/new']);
  }
}



// WEBPACK FOOTER //
// ./src/app/product/supplier-list-page.container.ts